import { END_STATUSES_CASE } from '@/const/cases';
import {
	CaseApplications,
	CaseProgressStepItem,
	ClientApproveStatus,
	Step,
	StatusTypes,
} from '@/interfaces';

interface CaseCardDisabledParams {
	status?: StatusTypes;
	stepName?: string;
	clientApproveEmail?: boolean;
}

export const isCaseCardDisabled = ({
	status,
	stepName,
	clientApproveEmail,
}: CaseCardDisabledParams): boolean | undefined =>
	status === 'Declined' && stepName !== 'Application in review'
		? clientApproveEmail
		: status === 'Archived' ||
		  status === 'Resolved Case' ||
		  (!!status && END_STATUSES_CASE.includes(status));

export const isCaseTimelineDisabled = (
	caseApplications: CaseApplications,
	clientApproveStatus?: ClientApproveStatus
): boolean | undefined =>
	!clientApproveStatus?.isApproved &&
	caseApplications.progress_status == 'Declined' &&
	caseApplications.step_name !== 'Application in review'
		? !clientApproveStatus?.isApproved && clientApproveStatus?.emailSent
		: END_STATUSES_CASE.includes(caseApplications.progress_status);

export const getCaseProgressSteps = (
	steps: Step[],
	currentIndex: number
): CaseProgressStepItem[] =>
	steps.map((step, index) => ({
		name: step.name,
		state:
			index < currentIndex
				? 'completed'
				: index === currentIndex
				? 'current'
				: 'upcoming',
	}));
